import React, { useCallback, useEffect, useState } from 'react'
import PointSystemType from '../GameSettings/PointSystemType'
import {
  CCard,
  CCardBody,
  CCol,
  CCollapse,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CRow,
  CSmartTable,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilListNumbered, cilOptions, cilPencil, cilSettings } from '@coreui/icons'
import GradeService from 'src/service/GradeService'
import GeneralService from 'src/service/GeneralService'
import PointSystem from './PointSystem'
import EditPointSetting from './EditPointSetting'
import StepperBar from '../SetupProgress/StepperBar'
const GradePoint = () => {
  const [loading, setLoading] = useState()
  const [gradePointData, setGradePointData] = useState([])

  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState([])
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [users, setUsers] = useState({})
  const [details, setDetails] = useState([])
  const [fixtureExists, setFixtureExists] = useState([])
  const [divShow, setDivShow] = useState(0)
  const [gradeDetail, setGradeDetail] = useState({})
  const [gamePointSystemType, setGamePointSystemType] = useState(0)
  const [teamView, setTeamView] = useState(null)
  const [gameFixtureExists, setGameFixtureExists] = useState(0)

  useEffect(() => {
    GeneralService.getUserGameInfo().then((res) => {
      if (res.data?.game_point_system_type !== undefined) {
        setGamePointSystemType(Number(res.data.game_point_system_type))
      }
      if (res.data?.team_view !== undefined) {
        setTeamView(Number(res.data.team_view))
      }
      setGameFixtureExists(Number(res.is_fixture_exists) || 0)
    })
  }, [])
  const columns = [
    {
      label: 'Comp Name',
      key: 'grade',
      filter: false,
    },
    {
      key: 'actions',
      label: 'Actions',
      _style: { width: '5%' },
      filter: false,
      sorter: false,
    },
  ]

  const toggleDetails = (index) => {
    setGradePointData([])
    setLoading(true)
    const position = details.indexOf(index)
    let newDetails = details.slice()
    if (position !== -1) {
      newDetails.splice(position, 1)
    } else {
      newDetails = [...details, index]
    }
    setDetails(newDetails)

    GradeService.gradePointSystem(index).then((res) => {
      setGradePointData(res.data)
      setFixtureExists(res.is_fixture_exists)
      setLoading(false)
    })
  }

  const fetchUsers = useCallback(async () => {
    setLoading(true)
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    try {
      const result = await GradeService.getGrades(offset, itemsPerPage, activePage, params)
      setUsers(result.data)
      setLoading(false)
    } catch (error) {
      console.error('Error fetching users:', error)
    } finally {
      setLoading(false)
    }
  }, [activePage, itemsPerPage, columnFilter, columnSorter])

  useEffect(() => {
    fetchUsers()
  }, [fetchUsers])
  return (
    <>
      <StepperBar activeStepKey="point_system" />
      {teamView === 0 && (
        <PointSystemType
          value={gamePointSystemType}
          onSaved={(newValue) => setGamePointSystemType(newValue)}
          teamView={teamView}
          fixtureExists={gameFixtureExists}
        />
      )}
      <div className="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-3">
        <div>
          <h4 className="mb-1">Point System</h4>
          <div className="text-medium-emphasis">
            Manage point value settings for each competition.
          </div>
        </div>
      </div>

      <CRow className="g-3 mb-3">
        <CCol sm={6} lg={4}>
          <CCard className="h-100">
            <CCardBody className="d-flex justify-content-between align-items-center">
              <div>
                <div className="text-medium-emphasis small">Total Comps</div>
                <div className="fs-4 fw-semibold">{users?.total ?? 0}</div>
              </div>
              <div
                className="d-flex align-items-center justify-content-center rounded-circle bg-primary-subtle text-primary"
                style={{ width: 42, height: 42 }}
              >
                <CIcon icon={cilListNumbered} size="lg" />
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>

      <style>{`
        .gp-table thead th:first-child,
        .gp-table tbody td:first-child {
          width: auto;
          text-align: left;
          padding-left: 1rem !important;
        }
      `}</style>
      <CCard>
        <CCardBody>
          <div className="ge-datatable ge-datatable--static gp-table">
            <CSmartTable
              columns={columns}
              columnFilter={{
                external: true,
              }}
              columnSorter={{
                external: true,
              }}
              scopedColumns={{
                actions: (item) => (
                  <td className="py-2">
                    <CDropdown alignment="end" portal>
                      <CDropdownToggle color="transparent" caret={false} className="p-0">
                        <CIcon icon={cilOptions} role="button" />
                      </CDropdownToggle>
                      <CDropdownMenu>
                        <CDropdownItem
                          role="button"
                          onClick={() => {
                            toggleDetails(item.id)
                            setDivShow(1)
                          }}
                        >
                          <CIcon icon={cilPencil} className="me-2" />
                          Edit Point System
                        </CDropdownItem>
                        <CDropdownItem
                          role="button"
                          onClick={() => {
                            toggleDetails(item.id)
                            setDivShow(2)
                            GradeService.getGradeDetail(item.id).then((res) => {
                              setGradeDetail(res.data)
                            })
                          }}
                        >
                          <CIcon icon={cilSettings} className="me-2" />
                          Edit Minimum
                        </CDropdownItem>
                      </CDropdownMenu>
                    </CDropdown>
                  </td>
                ),
                details: (item) => {
                  return (
                    <CCollapse visible={details.includes(item.id)}>
                      <CCardBody>
                        {divShow === 1 && (
                          <PointSystem
                            gradePointData={gradePointData}
                            setGradePointData={setGradePointData}
                            gradeId={item.id}
                            setLoading={setLoading}
                            toggleDetails={toggleDetails}
                            fixtureExists={fixtureExists}
                            fetchUsers={fetchUsers}
                            gamePointSystemType={gamePointSystemType}
                            teamView={teamView}
                          />
                        )}
                        {divShow === 2 && (
                          <EditPointSetting
                            gradeDetail={gradeDetail}
                            toggleDetails={toggleDetails}
                            fetchUsers={fetchUsers}
                          />
                        )}
                      </CCardBody>
                    </CCollapse>
                  )
                },
              }}
              items={users?.data}
              itemsPerPage={itemsPerPage}
              itemsPerPageSelect
              loading={loading}
              pagination={{
                external: true,
              }}
              paginationProps={{
                activePage: activePage,
                pages: Math.ceil(users?.total / itemsPerPage) || 1,
              }}
              tableProps={{ hover: true, responsive: true, className: 'align-middle mb-0' }}
              onActivePageChange={(activePage) => setActivePage(activePage)}
              onColumnFilterChange={(filter) => {
                setActivePage(1)
                setColumnFilter(filter)
              }}
              onItemsPerPageChange={(itemsPerPage) => {
                setActivePage(1)
                setItemsPerPage(itemsPerPage)
              }}
              onSorterChange={(sorter) => setColumnSorter(sorter)}
            />
          </div>
        </CCardBody>
      </CCard>
    </>
  )
}

export default GradePoint
